import React, { memo } from 'react';
import CurrencyFormat from 'components/ui/text-formats/CurrencyFormat';

function List({ list, field, decimalScale }) {
  return (
    <div className='h-[260px] min-w-[220px] grow w-full overflow-x-auto my-scroll'>
      {list?.map((item, i) => (
        <div key={i} className='flex items-center mb-1'>
          <span
            style={{
              background: item?.color,
              minWidth: '20px',
              width: '20px',
              height: '20px',
              display: 'inline-block',
              borderRadius: 20,
            }}
          />
          {item?.name}: &nbsp;{' '}
          <CurrencyFormat value={item?.[field]} decimalScale={decimalScale} />
        </div>
      ))}
    </div>
  );
}

export default memo(List);
